"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _react = _interopRequireDefault(require("react"));

var _dotUtils = require("dot-utils");

var _md = require("react-icons/md");

var _Wrapper = _interopRequireDefault(require("./Wrapper"));

var _styles = require("../styles");

var _Clickable = _interopRequireDefault(require("./Clickable"));

var _Title = _interopRequireDefault(require("./Title"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var _StyledWrapper = (0, _styledComponents["default"])(_Wrapper["default"]).withConfig({
  displayName: "ClosableMessage___StyledWrapper",
  componentId: "w2asiy-0"
})(["box-shadow:", ";position:relative;", ";"], _styles.boxShadow, function (p) {
  return p._css;
});

var _StyledClickable = (0, _styledComponents["default"])(_Clickable["default"]).withConfig({
  displayName: "ClosableMessage___StyledClickable",
  componentId: "w2asiy-1"
})(["position:absolute;top:", "px;right:", "px;> *{display:block;}"], _styles.baseSpacing, _styles.baseSpacing);

function ClosableMessage(_ref) {
  var title = _ref.title,
      _ref$open = _ref.open,
      open = _ref$open === void 0 ? true : _ref$open,
      _ref$onClose = _ref.onClose,
      onClose = _ref$onClose === void 0 ? function () {} : _ref$onClose,
      cssProp = _ref.css,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["title", "open", "onClose", "css", "children"]);

  var _useStateEffect = (0, _dotUtils.useStateEffect)(open),
      _useStateEffect2 = _slicedToArray(_useStateEffect, 2),
      isOpen = _useStateEffect2[0],
      setIsOpen = _useStateEffect2[1];

  if (!isOpen) {
    return null;
  }

  return /*#__PURE__*/_react["default"].createElement(_StyledWrapper, _extends({
    background: '#fff',
    borderRadius: _styles.borderRadius,
    py: _styles.baseSpacing,
    px: _styles.baseSpacing * 2
  }, props, {
    _css: cssProp
  }), title && /*#__PURE__*/_react["default"].createElement(_Title["default"], {
    mt: 0,
    mb: _styles.baseSpacing
  }, title), children, /*#__PURE__*/_react["default"].createElement(_StyledClickable, {
    fontSize: 22,
    onClick: function onClick() {
      setIsOpen(!isOpen);
      onClose();
    }
  }, /*#__PURE__*/_react["default"].createElement(_md.MdClose, null)));
}

var _default = ClosableMessage;
exports["default"] = _default;